import _ from 'lodash';
import React from 'react';

import {
  LeaseApplicationStepNameName,
  useOrderDetailActivityQuery
} from 'generated/graphql';

import { DateTime } from 'luxon';



export interface IData {
  orderId: string;
  orderNumber: string;
  orderDate: DateTime;

  headerKeys: string[];
  detailKeys: string[];
  addressKeys: string[];

  headerKey2Value: _.Dictionary<string>;
  addressRow2Value: _.Dictionary<string>;
  detailRowsRow2Value: Array<_.Dictionary<string>>;

  rawShipStationOrder: string;
  rawShipStationShipment: string;
  rawSourceOrder: string;

  trackingNumber: string;
  carrierCode: string;

  paymentMethodDisplayName: string;
  orderStatusDisplayName: string;

  customerFullName: string;
  customerEmail: string;

  smartPayApplicationNumber: string;
  completedSteps: LeaseApplicationStepNameName[];

  deviceLedgerInfo: Array<{
    sku: string;
    imei: string;
    iccid: string;
  }>;
}



export function useQuery(orderId: string) {
  const queryTuple = useOrderDetailActivityQuery({
    variables: {
      orderId
    }
  });



  const wrappedTuple = React.useMemo(() => {
    const order = queryTuple.data?.order;
    const e1Data = order?.e1Data;

    const data: IData = {
      orderDate: DateTime.fromISO(order?.orderDate ?? ''),
      orderId: order?.id ?? '',
      orderNumber: order?.orderNumber ?? '',

      headerKeys: _.sortBy(_.map(e1Data?.headerRow ?? [], row => row.columnName)),
      detailKeys: _.sortBy(_.uniq(_.flatMap(e1Data?.detailRows, row => _.map(row, r => r.columnName)))),
      addressKeys: _.sortBy(_.map(e1Data?.addressRow, row => row.columnName)),

      headerKey2Value: _.mapValues(_.keyBy(e1Data?.headerRow ?? [], row => row.columnName), val => val.value),
      addressRow2Value: _.mapValues(_.keyBy(e1Data?.addressRow ?? [], row => row.columnName), val => val.value),
      detailRowsRow2Value: _.map(e1Data?.detailRows ?? [], row => _.mapValues(_.keyBy(row, r => r.columnName), val => val.value)),
      rawShipStationOrder: JSON.stringify(order?.shipStationOrder?.rawData ?? {}, undefined, 2),
      rawShipStationShipment: JSON.stringify(order?.shipStationShipment?.rawData ?? {}, undefined, 2),
      rawSourceOrder: JSON.stringify(order?.rawSourceOrder?.rawData ?? {}, undefined, 2),
      trackingNumber: order?.shipment?.trackingNumber ?? '',
      carrierCode: order?.shipment?.carrierCode ?? '',

      orderStatusDisplayName: order?.status.displayName ?? 'N/A',
      paymentMethodDisplayName: order?.netSuitePaymentMethod?.name ?? order?.paymentMethod.displayName ?? 'N/A',
      smartPayApplicationNumber: order?.smartPayLeaseApplication?.applicationNumber ?? '',
      customerFullName: order?.customer.firstName + ' ' + order?.customer.lastName,
      customerEmail: order?.customer.email || 'N/A',
      completedSteps: _.map(_.filter(order?.smartPayLeaseApplication?.steps, step => step.status.name === 'complete'), step => step.name.name),
      deviceLedgerInfo: queryTuple.data?.order?.e1DeviceLedger ?? []
    };

    return {
      data,
      loading: queryTuple.loading
    };
  }, [queryTuple]);



  return wrappedTuple;
}
